export var PullThreshold = 80;